export default __webpack_public_path__ + "static/media/polkadot.fc599ad2.svg";